// regulatory / policy banner data
export const regulatoryPolicyList = {
  banner: {
    en: [
        {
         name: 'China Economic Monitor: 2026 Q3',
         desc: 'KPMG China today released Q3 edition of the 2026 China Economic Monitor.',
         linkUrl: 'https://kpmg.com/cn/en/insights/2026/08/china-economic-monitor-q3-2026.html',
         imgSrc: require(`@/assets/img/clientUser/EN/banner04.png`),
         date: '10/08/2026'
       },
      {
        name: 'Chinese Mainland and Hong Kong IPO Markets: 2026 Q1 Review',
        desc: 'Chinese Mainland and Hong Kong IPO Markets 2026 Q1 Review',
        linkUrl: 'https://kpmg.com/cn/en/insights/2026/04/china-hk-ipo-2026-q1-review.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner01.png`),
        date: '09/04/2026'
      },
      {
        name: 'Hong Kong Capital Markets Update – Issue 01, March 2026',
        desc: 'HKEX’s consultation on proposals to enhance listing competitiveness',
        linkUrl: 'https://kpmg.com/cn/en/insights/2026/03/hk-capital-markets-01-26.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner09.png`),
        date: '24/03/2026'
      },
      {
        name: 'Hong Kong Budget Summary 2026-2027',
        desc: 'Highlights and KPMG\'s commentary on the Hong Kong Budget',
        linkUrl: 'https://kpmg.com/cn/en/insights/2026/02/hong-kong-budget-2026-2027.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner05.png`),
        date: '25/02/2026'
      },
      {
        name: 'Enhancing Accountability: Revised Corporate Governan... - KPMG China',
        desc: 'Revised Corporate Governance Code On Risk Management and Internal Control Systems:Four Essential Questions For Directors To Ask & Answer',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/09/enhancing-accountability.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner10.png`),
        date: '25/09/2025'
      },
      {
        name: 'The implications of the FSTB Sustainability Reporting Roadmap for Hong Kong Companies - KPMG China',
        desc: 'The Financial Services and the Treasury Bureau issued a roadmap for wider adoption of sustainability reporting in Hong Kong',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/05/the-implications-of-the-fstb-sustainability-reporting-roadmap-for-hk-companies.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner02.png`),
        date: ''
      },
      {
        name: 'China Tax Insight - KPMG China',
        desc: 'These publications provide in-depth tax analysis and practical insights for businesses operating in China’s key economic and industrial sectors.',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2020/05/china-tax-insights.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner03.png`),
        date: ''
      },
      {
        name: 'Personal information protection compliance audit management and response - KPMG China',
        desc: 'KPMG China provides an in-depth understanding of the core requirements of...',
        linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/03/personal-information-protection-compliance-audit-management-and-response.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner06.png`),
      },
      {
        name: 'Guides to HKFRS financial statements - KPMG China',
        desc: 'Example financial statements for companies incorporated or listed in Hong Kong',
        linkUrl: 'https://kpmg.com/cn/en/home/services/audit/accounting-and-reporting-focus/guides-to-hkfrs-financial-statements.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner07.png`),
        date: ''
      },
      {
        name: 'Financial Reporting Webinar Series - KPMG China',
        desc: 'Our webinar series cover the latest financial reporting issues and insights on related matters.',
        linkUrl: 'https://kpmg.com/cn/en/home/services/audit/accounting-and-reporting-focus/financial-reporting-webinar-series.html',
        imgSrc: require(`@/assets/img/clientUser/EN/banner08.png`),
        date: ''
      },
    ],
    zh: [
      {
        name: '金融监管合规参要（2026年第二季度）',
        desc: '聚焦监管动向 凝聚合规智慧',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/08/key-points-of-financial-regulation-compliance-q2.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner01.png`),
        date: '24/08/2026'
      },
      {
        name: '第七期：全球金融监管动态月刊（2026年7月刊）',
        desc: '洞察全球金融监管政策及趋势',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/08/global-fs-regulation-monthly-update-07.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner05.png`),
        date: '21/08/2026'
      },
      {
        name: '中国经济观察：2026年三季度',
        desc: '毕马威发布2026年三季度《中国经济观察》：人工智能引领经济新动能',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/08/china-economic-monitor-q3-2026.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner08.png`),
        date: '10/08/2026'
      },
      {
        name: '国资国企热点深度解析（2026年二季度刊）',
        desc: '《国资国企热点深度解析季度合刊》提炼当季政策重点，帮助国资国企管理者了解监管趋势及其带来的重要影响，并提出具有针对性的建议。 《国资国企热点深度解析（2026年二季度刊）》内容涵盖《关于进一步深化国资国企改革的方案（2026—2029年）》、打好“五大攻坚战”、央企发力基础研究、强化产权管理、低空经济发展等主题。',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/07/analytics-of-hot-topics-in-soe-2026-q2.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner09.png`),
        date: '31/07/2026'
      },
      {
        name: '“监”听则明：2026年二季度金融业监管数据处罚分析及洞察建议',
        desc: '2026年二季度金融业监管数据处罚分析及洞察建议',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/07/financial-industry-regulation-q2-2026-data-penalty-analysis-and-insight-suggestions.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner11.png`),
        date: '10/07/2026'
      },
      {
        name: '商业银行内审观察（2026年一季度刊）',
        desc: '商业银行内审观察',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/05/internal-audit-observation-of-commercial-banks-2026-q1.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner19.png`),
        date: '14/05/2026'
      },
      {
        name: '全球保险公司2025年度财务报告概览——IFRS 17实时追踪',
        desc: '《全球保险公司2025年度财务报告概览——IFRS 17实时追踪》研究覆盖全球55家保险公司的公开披露信息，聚焦按照IFRS 17编制财务报告的实践成果，为全球保险机构合规运营、价值管理与战略决策提供权威参考。',
        linkUrl: 'https://kpmg.com/cn/zh/insights/ifrg/2026/2025-annual-reports-real-time-ifrs17.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner20.png`),
        date: '12/05/2026'
      },
      {
        name: '中国内地与香港IPO市场：2026年第一季度回顾',
        desc: '中国内地和香港IPO市场2026年第一季度回顾',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/04/china-hk-ipo-2026-q1-review.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner04.png`),
        date: '09/04/2026'
      },
      {
        name: '香港资本市场通讯 – 2026年3月，第1期',
        desc: '联交所就提升上市机制竞争力的建议咨询市场意见',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/hk-capital-markets-01-26.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner17.png`),
        date: '24/03/2026'
      },
      {
        name: '2025年度商业银行内审观察',
        desc: '毕马威中国商业银行内审观察系列刊物',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/02/internal-audit-observation-of-commercial-banks-2025.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner02.png`),
        date: '28/02/2026'
      },
      {
        name: '香港2026-2027年度財政預算案',
        desc: '香港政府財政預算案的重點和畢馬威的意見',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/02/hong-kong-budget-2026-2027.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner06.png`),
        date: '25/02/2026'
      },
      {
        name: '自然相关报告',
        desc: '国际可持续准则理事会拟制定自然相关报告新要求',
        linkUrl: 'https://kpmg.com/cn/zh/insights/ifrg/2026/issb-nature-reporting.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner10.png`),
        date: '05/02/2026'
      },
      {
        name: '税收优惠的会计核算',
        desc: '为企业答疑解惑',
        linkUrl: 'https://kpmg.com/cn/zh/services/audit/accounting-and-reporting-focus/financial-reporting-news/qa-tax-incentives.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner16.png`),
        date: '04/02/2026'
      },
      {
        name: '可返还的税收抵免',
        desc: '税收优惠的会计核算',
        linkUrl: 'https://kpmg.com/cn/zh/insights/ifrg/2026/qa-tax-incentives-refundable-credits.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner14.png`),
        date: '04/02/2026'
      },
      {
        name: '不可返还且不可转让的税收抵免',
        desc: '税收优惠的会计核算',
        linkUrl: 'https://kpmg.com/cn/zh/insights/ifrg/2026/qa-tax-incentives-nonrefundable-nontransferable-credits.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner13.png`),
        date: '04/02/2026'
      },
      {
        name: '不可返还但可转让的税收抵免',
        desc: '税收优惠的会计核算',
        linkUrl: 'https://kpmg.com/cn/zh/insights/ifrg/2026/qa-tax-incentives-nonrefundable-transferable-credits.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner15.png`),
        date: '04/02/2026'
      },
      {
        name: '全球视野——金融监管新动向与风险展望',
        desc: '金融监管新动向与风险展望',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/01/global-perspective-new-trends-in-financial-regulation-and-risk-outlook.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner12.png`),
        date: '01/27/2026'
      },
      {
        name: '中国税务洞察-毕马威中国',
        desc: '凭借我们丰富的专业知识和经验，为在中国主要经济行业领域运营的企业深度分析中国税务领域变化，并有针对性地提出实践洞察。',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2020/05/china-tax-insights.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner03.png`),
        date: ''
      },
      {
        name: '个人信息保护合规审计管理与应对 - 毕马威中国',
        desc: '2025年2月14日国家互联网信息办公室正式发布《个人信息保护合规审计管理办法》（以下简称“《审计办法》”），自2025年5月1日起施行。',
        linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/03/personal-information-protection-compliance-audit-management-and-response.html',
        imgSrc: require(`@/assets/img/clientUser/CN/banner07.png`),
        date: ''
      },
    ]
  },
}

// tech transformation data
export const techTransformationList = {
  en: [
    {
      name: 'KPMG Global Tech Report 2026: Government and public sector',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/04/global-tech-report-government-and-public-sector.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_01.png`),
    },
    {
      name: 'Cybersecurity considerations 2026',
      linkUrl: 'Building trust and enabling innovation in a dynamic world',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_02.png`),
    },
    {
      name: 'KPMG Global Tech Report 2026: Private company',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/04/global-tech-report-private-company.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_03.png`),
    },
    {
      name: '2026 Global M&A Outlook',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/03/2026-global-m-and-a-outlook.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_04.png`),
    },
    {
      name: 'Creating Total Value: Connecting experience and performance to drive growth in B2B',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/03/creating-total-value-connecting-experience-and-performance-to-drive-growth-in-b2b.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_05.png`),
    },
    {
      name: 'Global Construction Survey 2025-2026',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/03/global-construction-survey-2025-2026.html',
      imgSrc: require(`@/assets/img/clientUser/EN/Tech_06.png`),
    },
  ],
  zh: [
      {
        name: '智启新纪元：产业 AI 融合的范式跃迁与最佳实践',
        desc: '本白皮书深入剖析AI技术牵引的产业变革，探究新周期下的产业AI融合进程，旨在得出企业人工智能变革路径与必要举措，并通过领先实践拆解，为企业把握智能体时代的转型方向、能力短板和落地路径提供有益参考。',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/08/ignite-the-future-of-ai-transforming-industry-through-ai-integration-and-best-practices.html',
        imgSrc: require(`@/assets/img/clientUser/CN/Tech_01.png`),
      },
      {
        name: '跨越奇点：世界模型如何重塑具身智能产业与商业新范式',
        desc: '本报告从一级市场投融资分析切入，指出赋予机器人物理直觉的世界模型突破具身智能数据与泛化等多重瓶颈的核心。在此基础上，报告系统剖析了世界模型的定义、四大技术流派及多维评测体系，并结合机械臂、自动驾驶与人形机器人等场景详述了其商业落地实践。最后，全面展望了世界模型引领下具身智能在技术、商业与生态范式上的未来演进趋势。',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/07/how-world-models-are-reshaping-the-embodied-intelligence-industry-and-new-business-paradigms.html',
        imgSrc: require(`@/assets/img/clientUser/CN/Tech_02.png`),
      },
      {
        name: '毕马威2026全球技术报告',
        desc: '报告基于毕马威面向全球27个国家、2,500名科技高管的调研数据，覆盖汽车、金融服务、工业制造、科技和电信等八个行业，通过对技术成熟度、数字技术投资回报率等关键维度的分析，我们试图探讨“企业是否能在巨变中茁壮成长”。 报告紧扣“全球视野，中国实践”的核心主张，聚焦技术演进新特质与产业数智转型新未来，为企业管理者提供切实有用的行动建议。',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/global-tech-report-2026.html',
        imgSrc: require(`@/assets/img/clientUser/CN/Tech_04.png`),
      },
    {
      name: '释放潜力：生成式人工智能对中国生命科学行业的影响',
      desc: 'GenAI的应用推动了中国生命科学行业的突破，包括药物开发、医患互动以及临床试验优化',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/the-impact-of-generative-artificial-intelligence-on-the-life-sciences-industry-in-china.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_03.png`),
    },
    {
      name: '毕马威全球技术报告2026：能源行业洞察',
      desc: '当前，随着“企业科技化”时代的到来以及人工智能的快速发展，能源行业正加速推进技术与运营的深度融合。',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/kpmg-global-tech-energy-natural-resources-and-chemicals.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_05.png`),
    },
    {
      name: '第25届毕马威全球汽车高管中国调研报告',
      desc: '致胜未来，通向未来的领导力蓝图',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/25th-annual-global-automotive-executive-survey.html',
      imgSrc: require(`@/assets/img/clientUser/CN/Tech_06.png`),
    },
  ]
}

// insights data 带分页
export const insightsList = {
  en: [
    {
      name: 'Hong Kong Asset Management and Private Equity Outlook',
      desc: 'Key trends and developments on tax reform, liquidity and growth',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/07/hong-kong-asset-management-and-private-equity-outlook.html',
      date: '08/14<br />2026'
    },
    {
      name: 'Hong Kong Capital Markets Update – Issue 02, July 2026',
      desc: 'HKEX’s consultation conclusions on proposals to enhance listing competitiveness',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/07/hk-capital-markets-02-26.html',
      date: '07/31<br />2026'
    },
    {
      name: 'Hong Kong Banking Report 2026',
      desc: 'Positioned for Growth',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/06/hong-kong-banking-report-2026.html',
      date: '06/18<br />2026'
    },
    {
      name: '2025 KPMG Hong Kong Audit Quality Report',
      desc: 'Building trust through quality and innovation',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/06/2025-kpmg-hk-audit-quality-report.html',
      date: '06/16<br />2026'
    },
    {
      name: 'AI Governance Principles for Boards',
      desc: 'Supporting responsible AI oversight at board level.',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/05/ai-governance-principles-for-board.html',
      date: '05/15<br />2026'
    },
    {
      name: 'Pulse of Private Equity Q1’26',
      desc: 'A KPMG quarterly analysis of global private equity activity.',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/05/pulse-of-private-equity-q1-26.html',
      date: '05/14<br />2026'
    },
    {
      name: 'ESG Bulletin 2026 Issue 02',
      desc: 'Provides a concise overview of key ESG regulatory developments across Hong Kong SAR, Chinese Mainland and global standard setters, including updates on sustainability assurance, climate disclosure standards and emerging nature-related reporting trends.',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/05/esg-bulletin-02.html',
      date: '05/13<br />2026'
    },
    {
      name: 'Hong Kong Employment Outlook 2026',
      desc: 'Market Outlook | AI Acceleration | Compensation Trends | Talent Management | Benefits',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/03/hong-kong-employment-outlook-2026.html',
      date: '04/08<br />2026'
    },
    {
      name: 'Winning the carve-out relay',
      desc: 'From team selection to the finish line. Designing, executing and winning Consumer and Industrials carve-outs',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/03/winning-the-carve-out-relay.html',
      date: '03/20<br />2026'
    },
    {
      name: 'Chinese Mainland Banking Survey 2025 Summary',
      desc: 'Moving in sync: the key to success',
      linkUrl: 'https://kpmg.com/cn/en/insights/2025/06/china-banking-industry-survey-report-2025.html',
      date: '01/23<br />2026'
    },
    {
      name: 'Hong Kong Banking Outlook 2026',
      desc: 'Key trends and predictions for the year ahead',
      linkUrl: 'https://kpmg.com/cn/en/insights/2026/01/hong-kong-banking-report-2026.html',
      date: '01/22<br />2026'
    },
    {
      name: '2025 KPMG MNC China Outlook Report - KPMG China',
      desc: '2025 MNC China Outlook Report not only reveals MNCs’ economic growth outlook, but also the strategic shifts and operational changes...',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/11/2025-kpmg-mnc-china-outlook-report.html',
      date: '12/22<br />2025'
    },
    {
      name: 'Global Customer Experience Excellence (CEE) 2025-2026 - KPMG China',
      desc: 'A benchmark study now in its 16th year, CEE captures perspectives from over 80,000 consumers across 16 markets worldwide',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/12/global-customer-experience-excellence-2025-2026.html',
      date: '12/03<br />2025'
    },
    {
      name: 'Value creation in private equity - KPMG China',
      desc: 'From stock-pickers to the quant PE house',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/11/value-creation-in-private-equity.html',
      date: '12/03<br />2025'
    },
    {
      name: 'Decoding Value: the metrics and drivers of value... - KPMG China',
      desc: 'The metrics and drivers of value creation',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/11/decoding-value.html',
      date: '11/24<br />2025'
    },
    {
      name: 'Q3’25 Venture Pulse Report - KPMG China',
      desc: 'KPMG Private Enterprise quarterly global report on venture capital trends.',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/10/venture-pulse-q3-25.html',
      date: '11/14<br />2025'
    },
    {
      name: 'Redefining Beauty: Navigating Chinas Medical Aesthetics - KPMG China',
      desc: 'The medical aesthetics industry in China is experiencing a transformative phase, establishing itself as a leading global market segment...',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/11/china-medical-aesthetics-industry.html',
      date: '11/06<br />2025'
    },
    {
      name: 'Hong Kong Private Wealth Management Report 2025 - KPMG China',
      desc: 'In-depth view of the current industry landscape, growth opportunities and vision for 2030',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/11/hong-kong-private-wealth-management-report-2025.html',
      date: '11/06<br />2025'
    },
    {
      name: 'Evolving asset management regulation 2025 report - KPMG China',
      desc: 'Igniting growth',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/09/evolving-asset-management-regulation-2025-report.html',
      date: '10/25<br />2025'
    },
    {
      name: '2025 Emerging Trends in Infrastructure and Transport... - KPMG China',
      desc: 'The ten key trends reshaping infrastructure and transport, from supply chains to sustainability, digitalization, and resilience',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/10/emerging-trends-in-infrastructure-and-transportation-industries.html',
      date: '10/23<br />2025'
    },
    {
      name: 'Chinese New Energy Enterprises “Going Abroad” Series: Sailing to Europe and America - KPMG China',
      desc: 'This report covers the two developed markets of Europe and the United States, focusing on core new energy sub-sectors...',
      linkUrl: 'https://kpmg.com/cn/en/home/insights/2025/05/europe-and-america-new-energy-market.html',
      date: '07/21<br />2025'
    },
  ],
  zh: [
      {
        name: '香港资本市场通讯 – 2026年7月， 第02期',
        desc: '联交所就提升上市机制竞争力的建议发布咨询总结',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/07/hk-capital-markets-02-26.html',
        date: '07/31<br />2026'
      },
      {
        name: '2025年度透明度报告',
        desc: '以质筑信，以新致远',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/07/2025-kpmg-hz-transparency-report.html',
        date: '07/31<br />2026'
      },
      {
        name: '2026年中国银行业调查报告',
        desc: '智网关键 挥拍精准',
        linkUrl: 'https://kpmg.com/cn/zh/insights/2026/07/china-banking-industry-survey-report-2026.html',
        date: '07/02<br />2026'
      },
    {
      name: '2026年中国便利店发展报告',
      desc: '毕马威中国始终密切关注便利店行业的发展脉络，并与中国连锁经营协会联合发布《2026年中国便利店发展报告》。该报告立足于当前宏观经济形势与行业最新动态，深入剖析便利店行业发展概况及行业热点，聚焦在自有品牌建设、多业态竞争、市场拓展、技术创新等方面的实践成果，旨在为行业从业者提供有价值的参考与思考。',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/05/china-convenience-store-development-report-2026.html',
      date: '05/22<br />2026'
    },
    {
      name: '数智开新局，场景促增长——2026年中国餐饮企业发展报告',
      desc: '《数智开新局，场景促增长——2026年中国餐饮企业发展报告》由毕马威中国联合广东省餐饮服务行业协会、深圳市烹饪协会共同发布。2025年作为"十四五"收官与"十五五"布局之年，餐饮行业虽面临存量竞争加剧、客单价下行等挑战，但仍展现出强劲韧性，全年餐饮收入同比增长3.2%，下沉市场扩容与资本市场回暖成为亮点。报告以详实数据和专业视角，聚焦中国餐饮业在关键转型期的发展态势，深入剖析餐饮企业在投融资、上市、AI技术赋能、全球化拓展、新兴场景化消费等方面的积极探索与痛点，以期为餐饮企业资本化运作与可持续发展提供策略指引，助力行业把握机遇、穿越周期。',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/05/2026-china-food-and-beverage-enterprise-development-report.html',
      date: '05/20<br />2026'
    },
    {
      name: '2026年香港就业市场展望',
      desc: '市场展望 | 人工智能的加速应用 | 薪酬趋势 | 人才管理 | 员工福利',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/hong-kong-employment-outlook-2026-sc.html',
      date: '04/08<br />2026'
    },
    {
      name: '情绪新宠，生态建构——潮玩行业全景洞察与趋势展望',
      desc: '全球化与本土化的交织为中国潮玩行业带来新的活力。毕马威发布《情绪新宠，生态建构——潮玩行业全景洞察与趋势展望》报告，《报告》从技术创新、IP开发、全球文化输出、社群经济、可持续发展以及IPO六个方面重点关注，洞悉潮玩行业未来新风口，为行业从业者揭示潮玩背后的文化逻辑与经济规律，提供具有战略价值的决策与参考。',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/04/panoramic-insights-and-trend-prospects-of-the-tide-play.html',
      date: '04/07<br />2026'
    },
    {
      name: '骐骥启新程——“十五五”规划宏观趋势与展望',
      desc: '毕马威发布《骐骥启新程——“十五五”规划宏观趋势与展望》，四大维度解读“十五五”高质量发展新内涵',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2026/03/the-macro-trends-and-prospects-of-the-15th-five-year-plan.html',
      date: '03/20<br />2026'
    },
    {
      name: '2026年中国银行业展望报告',
      desc: '因变立衡 向新致远',
      linkUrl: 'https://kpmg.com/cn/zh/insights/2025/12/china-banking-outlook-2026.html',
      date: '12/31<br />2025'
    },
    {
      name: '毕马威2025年跨国企业中国展望 - 毕马威中国',
      desc: '基于对中国境内137家跨国企业的见解，并在竞争加剧、本地化加深以及数字化和人工智能(AI)进步的背景下，《毕马威2025年跨国企业中国展望》不仅揭示了跨国企业的经济增长前景，还揭示了它们为适应不断变化的市场而进行的战略转变和运营变革。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/2025-kpmg-mnc-china-outlook-report.html',
      date: '12/22<br />2025'
    },
    {
      name: '2025年中国出口新动能与企业信心指数报告 - 毕马威中国',
      desc: '《2025年中国出口新动能与企业出口信心指数》由中国贸促会商业行业委员会与毕马威联合撰写，通过深入剖析中国出口情况的实时监测数据，揭示商品出口结构的动态变化及重点产业的发展态势，同时基于深度调研和产业案例，构建企业信心指数，前瞻性地探讨中国企业寻求中国出口新动能的领先实践路径。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/12/china-s-new-drivers-of-export-and-enterprise-export-confidence-index-2025.html',
      date: '12/09<br />2025'
    },
    {
      name: '青岛市市南区消费零售观察 - 毕马威中国',
      desc: '消费是拉动经济增长的主引擎。作为青岛主城核心区，市南区拥有丰富多元的消费供给和资源禀赋，通过改造焕新商业载体、发展“四首”经济、融合文商旅体等方式，在国际消费中心城市中心区打造中成效显著。毕马威发布《向新而行，活力焕发，青岛市市南区消费零售观察》报告，旨在为区域性的消费提振提供借鉴意义，并为消费零售',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/12/observation-on-the-consumer-retail-industry-in-shinan-district-qingdao.html',
      date: '12/05<br />2025'
    },
    {
      name: '2025中国黄酒产业中期报告 - 毕马威中国',
      desc: '《2025中国黄酒产业中期研究报告》观察到2025年是黄酒产业创新融合发展的关键时期。为牢牢把握“稳中求进、进中求优”的总基调，毕马威中国提出对黄酒行业未来发展的六大思考与建议。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/mid-term-report-on-china-s-yellow-wine-industry-2025.html',
      date: '11/21<br />2025'
    },
    {
      name: '中国工业品电商高质量发展白皮书（2025） - 毕马威中国',
      desc: '当前，中国工业品电商正处于快速发展的黄金期。毕马威推出的《中国工业品电商高质量发展白皮书》聚焦工业品电商的发展现状、价值重构与延申、挑战及趋势，全面剖析了工业品电商在推动产业升级、优化资源配置以及助力企业降本增效中的重要意义，为工业品电商企业提供行业洞察，助力企业把握政策与技术等机遇，抢占增长先机。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/china-s-industrial-e-commerce-high-quality-development-white-paper-2025.html',
      date: '11/18<br />2025'
    },
    {
      name: '“颜”值经济新篇章：2025年中国美妆市场行业报告 - 毕马威中国',
      desc: '本报告基于毕马威中国团队完善的知识体系与丰富的项目实践经验，深度剖析美妆行业的整体发展趋势及品牌与供应链的动态变化，深入洞察资本运作与二级市场动态，助力行业参与者把握未来发展方向，释放增长动能。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/2025-china-beauty-market-industry-report.html',
      date: '11/14<br />2025'
    },
    {
      name: '破局与重生：2025年中国酒店业的韧性之路 - 毕马威中国',
      desc: '本报告基于最新行业数据与案例，系统分析中国酒店业的发展现状、结构性矛盾与转型趋势，并通过端到端的解决方案旨在为从业者提供战略参考，揭示中国酒店业在挑战中突围的路径与机遇。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/the-resilience-road-of-china-s-hotel-industry-in-2025.html',
      date: '11/12<br />2025'
    },
    {
      name: '2025年中国首席执行官展望 - 毕马威中国',
      desc: '毕马威中国发布《2025年中国首席执行官展望》报告。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/2025-china-ceo-outlook.html',
      date: '11/06<br />2025'
    },
    {
      name: '重塑医美格局：驾驭中国医美新潮流 - 毕马威中国',
      desc: '中国的医美行业正处于变革阶段，不断演变为融合医疗、美容和科技的全球领先细分市场。随着业务的迅速扩张、政策环境的优化以及消费群体的结构性变化，中国医美行业有望塑造医美领域的未来格局。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/china-medical-aesthetics-industry.html',
      date: '11/06<br />2025'
    },
    {
      name: '市值管理——国资国企长期战略管理行为 - 毕马威中国',
      desc: '报告以“十五五”规划为契机，围绕高质量发展，深入分析国资国企市值管理的底层估值逻辑重构、国资国企内部战略重组与专业化整合以及破净股的业绩改善与提升等三大路径，并提出具体的解决方案，同时围绕国资国企市值管理提出建立控股股东和上市公司意识协同机制、利用“关键第三方”、构建市值管理考核体系三大保障措施。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/11/a-long-term-strategic-management-behavior-of-state-owned-enterprises.html',
      date: '11/06<br />2025'
    },
    {
      name: '低空经济的黄金时代：解构行业生态，助力企业绘就增长蓝图 - 毕马威中国',
      desc: '为帮助相关领域企业把握低空经济的发展机遇，毕马威中国推出了《低空经济的黄金时代：解构行业生态，助力企业绘就增长蓝图》报告，全面剖析了低空经济的现状，为企业提供了战略性的决策参考，助力其在低空经济的广阔蓝天中蓄势腾飞。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/10/the-golden-age-of-low-altitude-economy.html',
      date: '10/31<br />2025'
    },
    {
      name: '大变局：基建与交通运输行业新兴趋势 - 毕马威中国',
      desc: '报告基于全球十位基建领域资深负责人的实践洞见，并从各自的专业视角深入解读了全球变局对行业的深远影响。报告不仅包含了对现状的深刻分析，还提供了对未来发展的前瞻性预测。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/10/emerging-trends-in-infrastructure-and-transportation-industries.html',
      date: '10/23<br />2025'
    },
    {
      name: '毕马威中国生物科创领航50企业报告（第三届） - 毕马威中国',
      desc: '中国的生物科技行业在政策支持、市场需求以及技术创新的驱动下，正不断突破瓶颈，展现出强劲的发展势头。2024年毕马威中国启动第三届生物科创领航50企业评选活动。',
      linkUrl: 'https://kpmg.com/cn/zh/home/campaigns/2025/10/kpmg-china-biotech50-3rd-edition.html',
      date: '10/15<br />2025'
    },
    {
      name: '世界能源统计年鉴2025 - 毕马威中国',
      desc: '毕马威参与编纂的第74版《世界能源统计年鉴》正式发布。本次《年鉴》涵盖了2024年全球能源市场数据，呈现能源转型与地缘政治等因素交织下的复杂格局，是了解和驾驭全球能源趋势的重要参考资源。',
      linkUrl: 'https://kpmg.com/cn/zh/home/insights/2025/09/statistical-review-of-world-energy-2025.html',
      date: '09/18<br />2025'
    },
  ]
}
